import { css } from '@emotion/core';
import Background from '@assets/images/bg-wedding.webp';

export const styWrapper = css`
  background-image: url(${Background});
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 70vh;
  color: #fff !important;

  .bismillah {
    color: #fff !important;
    font-size: 16px !important;
    font-family: sans-serif;
  }

  .sub-title {
    color: #fff !important;
    font-size: 16px;
    font-family: 'Work Sans', Arial, sans-serif;
    font-weight: 400 !important;

    @media screen and (max-width: 400px) {
      font-size: 15px !important;
    }
  }

  .text__live {
    text-align: center;
    margin-top: 24px;
  }

  .main-font {
    margin-top: 12px;

    @media screen and (max-width: 400px) {
      line-height: 1;
      margin-bottom: 8px;
    }
  }
`;

export const styButtonWrapper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: pulse 2s ease infinite;
  margin-top: -8px;
  border: none;

  .img__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 500px;
    border-radius: 24px;
    background: #9ec35a;
    padding: 8px 16px;
  }

  i {
    margin-right: 4px;
  }

  img {
    max-width: 28px;
    margin-right: 8px;
    margin-bottom: 0;
  }
`;

export const styGuestInfoWrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 16px;
  flex-direction: row;

  > div {
    display: flex;
    flex: 1;
    height: 100%;

    .event-wrap {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
`;
